document.addEventListener("DOMContentLoaded", function () {

  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll(".zarf-section").forEach((section) => {

    const slides = section.querySelectorAll(".zarf-slide");

    // stack slides
    gsap.set(slides, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%"
    });

    // smooth timeline
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "+=" + (slides.length * 140) + "%",
        scrub: 1.5,
        pin: true,
        anticipatePin: 1
      }
    });

    slides.forEach((slide, i) => {

      const text = slide.querySelector(".text");
      const img = slide.querySelector("img");

      // ENTRY (soft + delayed)
      tl.fromTo(slide,
        { opacity: 0 },
        { opacity: 1, duration: 1, ease: "power2.out" },
        i * 1
      );

      if (text) {
        tl.fromTo(text,
          { y: 100, opacity: 0 },
          { y: 0, opacity: 1, duration: 1, ease: "power3.out" },
          i * 1 + 0.1
        );
      }

      if (img) {
        tl.fromTo(img,
          { y: 80, scale: 1.2, opacity: 0 },
          { y: 0, scale: 1, opacity: 1, duration: 1.2, ease: "power3.out" },
          i * 1
        );

        // subtle floating motion (Zarf feel)
        tl.to(img, {
          y: -60,
          duration: 2,
          ease: "none"
        }, i * 1);
      }

      // EXIT (overlap, not cut)
      if (i !== slides.length - 1) {
        tl.to(slide, {
          opacity: 0,
          duration: 1,
          ease: "power2.inOut"
        }, i * 1 + 0.7);
      }

    });

  });

});